/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { EnvWrapper } from "cms/auth/components/env-wrapper";
import { MinimalHeader } from "components/header/minimal-header";
import { Footer } from "components/footer";
import { FormContinue } from "@simplicitycms/simplicity-forms";

const FormContinuePage = () => {

    return (
        <>
            <EnvWrapper>
                <div className="simplicity-forms">
                    <div className="layout-with-footer">
                        <MinimalHeader />
                        <div id="layout-fullwidth" className="layout-fullwidth layout-margins">
                            <div className="main-content">
                                <div className="region region-content">
                                    <div className="content wysiwyg">
                                        <div id="block-system-main" className="block block-system">
                                            <FormContinue />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </EnvWrapper>
        </>
    );
};

export { FormContinuePage };
